<template>
  <div>
    <h1 v-if="hasSearchKey" class="text-uppercase">
      <span>Search results for:</span>
      <span>{{ search }}</span>
    </h1>
    <span v-if="noResults" class="text-muted">
      Sorry, but nothing matched your search criteria. Please try again with some different keywords.
    </span>
  </div>
</template>

<script>
export default {
  name: 'SearchResultsFor',
  props: {
    resultsCount: { type: Number, required: false, default: null }
  },
  data() {
    return {
      hasSearchKey: new URLSearchParams(window.location.search).has('search'),
      search: new URLSearchParams(window.location.search).get('search')
    }
  },
  computed: {
    noResults() {
      return this.resultsCount === 0
    }
  }
}
</script>
